import { getDrawerTypes } from '../registry';

/**
 * Host genérico do drawer de notificação. Despacha pelo registry: monta o `<Drawer>` self-contained de cada
 * tipo com `surfaces.drawer` (cada um se gateia por `activeType === key` e resolve seu próprio deep link).
 * Um único host em AppLayout serve todos os tipos. O deep link genérico via Knock (`knock.messages.get`)
 * saiu no AI-450 — cada tipo resolve seu deep link pela API (ex.: risco via `useNotifications`).
 */
const NotificationDrawer = () => (
  <>
    {getDrawerTypes().map((type) => {
      const TypeDrawer = type.Drawer!;
      return <TypeDrawer key={type.key} />;
    })}
  </>
);

export default NotificationDrawer;
